import { AbstractControl, ValidatorFn, ValidationErrors } from '@angular/forms';

/**
 * GSTIN Validator
 * Validates Indian GST Identification Number (15 characters)
 */
export function gstinValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {

        const gstin = control.value;

        // If empty, don't validate (use required validator separately if needed)
        if (!gstin) {
            return null;
        }

        // Convert to uppercase (GSTIN is always uppercase)
        const value = gstin.toUpperCase();

        // GSTIN Regex Pattern
        const gstinRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

        // Validate GSTIN format
        if (!gstinRegex.test(value)) {
            return { invalidGstin: true };
        }

        return null;
    };
}
